module.exports = __webpack_public_path__ + "static/img/jsgj_logo.2e6eaac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jsgj_logo.png
// module id = +pP+
// module chunks = 1